<template>
  <section
    v-if="category"
    class="headline"
    :style="{ '--color' : '#' + category.color }"
  >
    <div class="container">
      <div class="headline__content">
        <div class="headline__icon" v-html="category.svg"></div>
        <h1 class="headline__title">
          <span class="headline__title__legend">Cursos de</span>
          <strong class="headline__title__category">{{ category.name }}</strong>
        </h1>
      </div>
    </div>
    <!-- <div class="headline__icon--overlay" v-html="category.svg"></div> -->
  </section>
</template>

<script>
  export default {
    props: {
      category: { type: Object, default: () => ({}) }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .headline {
    position: relative;
    overflow: hidden;
    background: radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 0%, rgba(91, 0, 105, 0.70) 70%), var(--color);
    padding: 2.22222rem 4rem;

    &__content {
      display: flex;
      flex-direction: row;
      
      @media (max-width: $mobileBreakpoint) {
        flex-direction: column;
      }
    }

    &__icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 4.23rem;
      width: 4.23rem;
      padding: 12px;
      border-radius: 8px;
      margin-right: 24px;
      background-color: rgba(#fff, .10);

      ::v-deep svg { 
        fill: $white300 
      }

      &--overlay {
        position: absolute;
        top: 50%;
        right: 5%;
        transform: translateY(-50%);
        width: 10vw;
        opacity: .15;

        @media (max-width: 550px) {
          display: none;
        }

        ::v-deep svg { fill: #fff }
      }
    }

    &__title {
      display: flex;
      flex-direction: column;
      line-height: 2rem;

      &__legend {
        font-size: 1rem;
      }

      &__category {
        font-size: 2rem;
        font-family: $textSecondaryFamily;
        font-weight: 700;
      }
    }
  }
</style>